import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import DriverManagement from "./components/DriverManagement";
import RouteManagement from "./components/RouteManagement";
import ShopManagement from "./components/ShopManagement";
import DeliveryTransactionDashboard from "./components/DeliveryTransactionDashboard";
import ProductManagement from "./components/ProductManagement";
import AdminSingup from "./components/AdminSingup";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import PrivateRoute from "./components/PrivateRoute";
import Support from "./components/Support";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        <Route
          path="/*"
          element={
            <PrivateRoute>
              <div style={{ display: "flex" }}>
                <Sidebar />
                <div style={{ flex: 1 }}>
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/drivers" element={<DriverManagement />} />
                    <Route path="/routes" element={<RouteManagement />} />
                    <Route path="/shops" element={<ShopManagement />} />
                    <Route
                      path="/form"
                      element={<DeliveryTransactionDashboard />}
                    />
                    <Route path="/product" element={<ProductManagement />} />
                    <Route path="/admin" element={<AdminSingup />} />
                  </Routes>
                </div>
              </div>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
